export enum CashupConfigurationTypeEnum {
  standaloneEnabled = "Standalone Enabled",
  standaloneProEnabled = "Standalone Pro Enabled",
  excludeSales = "Exclude sales entered via product as revenue",
  denominationRestrictionEnabled = "Denomination Restriction Enabled"
}
